// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".register[data-v-3210f235]{text-align:center;padding:0 0;display:block}.register .text[data-v-3210f235]{color:#70726d}.register .link[data-v-3210f235]{font-weight:400;color:#040404;text-decoration:none}", ""]);
// Exports
module.exports = exports;
